import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/app/contexts/AuthContext';
import styles from './Header.module.scss';

interface HeaderProps {
  title: string;
  isSidebarOpen?: boolean;
  onToggleSidebar?: () => void;
  actions?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, isSidebarOpen, onToggleSidebar, actions }) => {
  const navigate = useNavigate();
  const { userProfile, signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <button
          className={styles.hamburgerButton}
          onClick={onToggleSidebar}
          aria-label="Toggle navigation menu"
          aria-expanded={isSidebarOpen}
        >
          <span>☰</span>
        </button>
        <h1 className={styles.pageTitle}>{title}</h1>
      </div>
      <div className={styles.headerRight}>
        {actions && (
          <div className={styles.headerActions}>
            {actions}
          </div>
        )}
        <div className={styles.userSection}>
          {userProfile?.email && (
            <span className={styles.userEmail}>
              {userProfile.displayName || userProfile.email}
              {userProfile.role && (
                <span className={styles.userRole}> ({userProfile.role})</span>
              )}
            </span>
          )}
          <button
            className={styles.logoutButton}
            onClick={handleLogout}
            aria-label="Logout"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

